import { CalendarEventModal } from "app/features/calendar/modals/CalendarEventModal";
import { useRef } from "react";
import { useRouter } from "expo-router";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { ShiftHandoverTaskClass } from "app/services/api/types/shiftHandover/classes/ShiftHandoverTaskClass";
import { SingleHandoverAppointmentModel } from "app/services/api/types/shiftHandover/models/SingleHandoverAppointmentModel";
import { AppointmentTypeEnums } from "app/services/api/types/calendar/enums/AppointmentTypeEnums";

type Appointment = ShiftHandoverTaskClass | SingleHandoverAppointmentModel;

export function useHandleShiftHandoverAppointments() {
  const ref = useRef<React.ComponentRef<typeof CalendarEventModal>>(null);
  const { navigate } = useRouter();
  const { residentId: contextResidentId } = useResidentContext();

  const handleAppointmentNavigation = (
    appointment: Appointment,
    residentId: number | undefined,
  ) => {
    if (!residentId) return ref.current?.showAppointment(appointment);

    switch (appointment.type) {
      case AppointmentTypeEnums.VITAL_CHECKS:
        return navigate(`/residents/${residentId}/parameters`);
      case AppointmentTypeEnums.MEDICATION_EVENT:
        return navigate(`/residents/${residentId}/medications`);
      case AppointmentTypeEnums.BARTHEL_INDEX:
        return navigate(`/residents/${residentId}/barthel-score`);
      case AppointmentTypeEnums.ACCIDENTS_INCIDENTS:
        return navigate(`/residents/${residentId}/accidents-and-incidents`);
      case AppointmentTypeEnums.NURSE_CARE_ASSESSMENT:
        return navigate(`/residents/${residentId}/care-plans`);
      case AppointmentTypeEnums.RESIDENT_STATE_REPORTING:
        return navigate(
          `/residents/${residentId}/reports/resident-state-reporting`,
        );
      case AppointmentTypeEnums.DAILY_REPORTING:
        return navigate(`/residents/${residentId}/reports/daily-reporting`);

      default:
        return ref.current?.showAppointment(appointment);
    }
  };

  const handleTaskRowPress = (task: ShiftHandoverTaskClass) => {
    handleAppointmentNavigation(task, contextResidentId);
  };

  const handleAppointmentRowPress = (
    residentId: number | undefined,
    appointment: SingleHandoverAppointmentModel,
  ) => {
    const id = residentId ?? contextResidentId;
    handleAppointmentNavigation(appointment, id);
  };

  return { ref, handleTaskRowPress, handleAppointmentRowPress };
}
